// Berklee College of Music's undergraduate majors (#2739). Read on
// 2026-10-01 from Berklee's official Bachelor of Music: Majors page
// (college.berklee.edu/majors), every Bachelor of Music major it lists, and
// from How to Apply, which names the two Bachelor of Arts programs (Black
// Music and Culture is also listed on the majors page; How to Apply makes it
// a BA). Principal instruments, minors, specializations, the Professional
// Diploma and Berklee Online and Boston Conservatory programs are left out.
const majors = {
    "slug": "berklee-college-of-music",
    "read": "2026-10-01",
    "intro": "Every Bachelor of Music major at Berklee's Boston campus, plus its two Bachelor of Arts programs. Minors, diplomas and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor of Music",
            "source": {
                "label": "Berklee, Bachelor of Music: Majors",
                "url": "https://college.berklee.edu/majors"
            },
            "majors": [
                {
                    "name": "Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Contemporary Writing and Production",
                    "degree": "B.M."
                },
                {
                    "name": "Electronic Production and Design",
                    "degree": "B.M."
                },
                {
                    "name": "Film Scoring",
                    "degree": "B.M."
                },
                {
                    "name": "Game and Interactive Media Scoring",
                    "degree": "B.M."
                },
                {
                    "name": "Global Jazz Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Independent Recording and Production",
                    "degree": "B.M."
                },
                {
                    "name": "Jazz Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Music Business/Management",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Music Production and Engineering",
                    "degree": "B.M."
                },
                {
                    "name": "Music Therapy",
                    "degree": "B.M."
                },
                {
                    "name": "Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Professional Music",
                    "degree": "B.M."
                },
                {
                    "name": "Songwriting",
                    "degree": "B.M."
                }
            ]
        },
        {
            "name": "Bachelor of Arts",
            "source": {
                "label": "Berklee Admissions, How to Apply",
                "url": "https://college.berklee.edu/admissions/undergraduate/how-to-apply"
            },
            "majors": [
                {
                    "name": "Black Music and Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Music Industry Leadership and Innovation",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
